<script lang="ts">
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import {exists} from 'shared/utils/custom-utils';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let icon: UIcons | null = null;
    export let value = 0;
    export let label = 'Default label';
    export let boxType: 'default' | 'info' = 'info';
</script>

<div class="kp-stats-number-info-box box-{boxType}" aria-label="{label}">
    {#if $$slots.default}
        <slot/>
    {:else}
        {#if exists(icon)}
            <div class="icon-container">
                <UIcon {icon}/>
            </div>
        {/if}

        <span class="value">{value}</span>

        <span class="value-label">{label}</span>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    @default-bg: #e7e7e7;
    @info-bg: #e3e8fa;
    @default-text: #333;
    @info-text: #2C33E4;

    .kp-stats-number-info-box {
        width: 100%;
        padding: 2em;
        border-radius: @border-radius-default;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        &.box-default {
            color: @default-text;
            background-color: @default-bg;
        }

        &.box-info {
            color: @info-text;
            background-color: @info-bg;
        }

        .icon-container {
            color: @info-text;
            margin-bottom: 12px;
            font-size: @font-size-large;
        }

        .value {
            font-size: @font-size-large;
            font-weight: 500;
            margin-bottom: @spacing-s;
        }

        .value-label {
            opacity: 0.75;
        }
    }
</style>